import React, { useEffect, useRef } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import MainPage from "./Components/MainPage";
import SignUpPage from "./Components/Signup/SignUpPage";
import OrderPage from "./Components/OrderPage/OrderPage";
import AboutPage from "./Components/AboutPage";
import ContactPage from "./Components/ContactPage";
import Shop from "./Components/Shop";
import Tryoutpage from "./Components/Try/Tryoutpage";
import History from "./Components/History";
import DeliveryStatus from "./Components/DeliveryStatus";
import AccountPage from "./Components/Account/AccountPage";
import FirstPage from "./Components/Consultation/FirstPage";
import SecondPage from "./Components/Consultation/SecondPage";
import ThirdPage from "./Components/Consultation/ThirdPage";
import BalanceSpaceFirstPage from "./Components/BalanceInSpaceConsultation/FirstPage";
import BalanceSpaceSecondPage from "./Components/BalanceInSpaceConsultation/SecondPage";
import BalanceSpaceThirdPage from "./Components/BalanceInSpaceConsultation/ThirdPage";
import MasterLayout from "./MasterComponents/MasterLayout";
import MainPageM from "./MasterComponents/MainPage";
import Courses from "./Components/Courses";
import NatalChart from "./Components/NatalChart";
import MasterImage from "./MasterComponents/MasterImage";
import SettingsPage from "./Components/Account/SettingsPage";
import LanguageSettings from "./Components/Account/LanguageSettings";
import AccountSecurity from "./Components/Account/AccountSecurity";
import MasterAppointments from "./MasterComponents/Appointments";
import MasterList from "./MasterComponents/UpcomingConsultation";
import ZoomAppointment from "./ZoomConference/ZoomAppointment";
import ZoomWhiteboard from "./ZoomConference/ZoomWhiteboard";
import ZoomBalanceInSpaceAppointment from "./ZoomBalanceinSpace/ZoomAppointment";
import Pricing from "./Components/Pricing";
import Return from "./Components/Footer/Return";
import Terms from "./Components/Footer/Terms";
import TermsConditions from "./Components/Signup/TermsandConditions";
import Blank from "./Components/Try/blank";
import Newsroom from "./Components/Newsroom";
import RewardsPartner from "./Components/RewardsPartner";
import InternalPartner from "./Components/InternalPartner";
import BalanceInSpace from "./Components/BalanceInSpace";

import DeliveryInformation from "./Components/Footer/DeliveryInfo";
import PrivacyPolicy from "./Components/Footer/Privacy";
import FAQs from "./Components/Footer/FAQs";
import TermsAndConditions from "./Components/Signup/TermsandConditions";
import Chatbot from "./Components/ChatBot/Chatbot";
import Chat from "./Components/Chat";
import FortuneStick from "./Components/FortuneStick";

import VisitorPage from "./Components/Visitor/VisitorPage";
import ProductListPage from "./Components/ProductListPage";
import Cart from "./Components/Cart";
import Checkout from "./Components/Checkout";
import CheckoutDemo from "./Components/CheckoutDemo/CheckoutDemo";
import PurchaseHistory from "./Components/PurchaseHistory";
import UpcomingConsultation from "./Components/Account/UpcomingConsultation";
import ElementFinder from "./Components/Visitor/ElementFinder";
import NatalChart2 from "./Components/NataChart2";
import DigitalCharm from "./Components/Account/DigitalCharm";
import { GLOBAL_FONT, textStyles } from "./utils/globalStyles";
import ScrollToTop from "./Components/ScrollToTop";
import { ProfileProvider } from "./Components/Try/ProfileContext";
import i18n from "./i18n";
import { syncProfileLanguageFromGetProfile } from "./utils/profileLanguageSync";
import { trackPageView } from "./utils/analytics";

import Partner from "./CompVIP/Partner";
import MainMaster from "./CompVIP/MainMaster";
import Wallet from "./Components/Wallet";

const ROUTER_BASENAME = "";

function App() {
  const languageBootstrapRanRef = useRef(false);

  useEffect(() => {
    if (languageBootstrapRanRef.current) {
      return;
    }
    languageBootstrapRanRef.current = true;

    let isMounted = true;

    const syncLanguageOnAppStart = async () => {
      if (localStorage.getItem("isLoggedIn") !== "true") {
        return;
      }

      const userId = localStorage.getItem("userID");
      if (!userId) {
        return;
      }

      // Skip on the signup page: it manages its own language via a `?lang=` URL param
      // (e.g. from a QR/share link), and this sync would otherwise race with that and
      // silently overwrite it with whatever language is saved on an unrelated, already
      // logged-in session's profile (e.g. a shared link opened in a browser that still
      // has an old session signed in).
      if (window.location.pathname.includes("/signup")) {
        console.log("[App] Skipping profile-language auto-sync on the signup page.");
        return;
      }

      const previousLanguage = localStorage.getItem("language") || "en";

      await syncProfileLanguageFromGetProfile({
        userId,
        userName: localStorage.getItem("username") || "",
      });

      if (!isMounted) {
        return;
      }

      const syncedLanguage =
        localStorage.getItem("language") || previousLanguage;
      if (syncedLanguage && syncedLanguage !== i18n.language) {
        await i18n.changeLanguage(syncedLanguage);
      }
    };

    syncLanguageOnAppStart();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <Router basename={ROUTER_BASENAME}>
      <ProfileProvider>
        <div>
          <ScrollToTop />
          <PageViewTracker />
          <RouteErrorBoundary>
          <Routes>
            {/* <Route path="/" element={<AccountPage />}/> */}
            <Route path="/" element={<Navigate to="/main" replace />} />
            <Route path="/" element={<Tryoutpage />}>
              {/* <Route path="/main" element={<MainPage />} /> */}
              <Route path="/schedule" element={<FirstPage />} />
              <Route path="/schedule2" element={<SecondPage />} />
              <Route path="/schedule3" element={<ThirdPage />} />
              <Route path="/balance-in-space-schedule" element={<BalanceSpaceFirstPage />} />
              <Route path="/balance-in-space-schedule2" element={<BalanceSpaceSecondPage />} />
              <Route path="/balance-in-space-schedule3" element={<BalanceSpaceThirdPage />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/history" element={<History />} />
              <Route path="/deliverystatus" element={<DeliveryStatus />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="language-settings" element={<LanguageSettings />} />
              <Route path="account-security" element={<AccountSecurity />} />
              <Route path="/courses" element={<Courses />} />
              <Route path="/chart" element={<NatalChart />} />
              <Route path="/natal" element={<NatalChart />} />
              <Route path="/chart2" element={<NatalChart2 />} />
              <Route path="/chat" element={<Chat />} />
              <Route path="/fortune-stick" element={<FortuneStick />} />
              {/* <Route path="/chart2" element={<Chart />} /> */}
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/affiliatepartner" element={<RewardsPartner />} />
              <Route path="/balanceinspace" element={<BalanceInSpace />} />
              <Route path="/internal" element={<InternalPartner />} />
              <Route path="/returnpolicy" element={<Return />} />
              {/* <Route path="/termsandconditions" element={<TermsConditions />} /> */}
              <Route path="/blank" element={<Blank />} />
              <Route path="/newsroom" element={<Newsroom />} />
              <Route path="/deliveryinfo" element={<DeliveryInformation />} />
              <Route path="/privacyinfo" element={<PrivacyPolicy />} />
              <Route path="/terms-conditions" element={<Terms />} />
              <Route path="/faqs" element={<FAQs />} />
              <Route path="/chatbot" element={<Chatbot />} />
              <Route path="/visitor" element={<VisitorPage />} />
              <Route path="/product/:id" element={<ProductListPage />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/purchasehistory" element={<PurchaseHistory />} />
              <Route path="/myappointment" element={<UpcomingConsultation />} />
              <Route path="/DigitalCharm" element={<DigitalCharm />} />
            </Route>
            <Route path="/signup/:promocode?" element={<SignUpPage />} />
            <Route path="/order" element={<OrderPage />} />

            <Route path="/main" element={<MainPage />} />
            {/* Zoom Video SDK conference — canonical routes. Rendered top-level
              (no site/master chrome) since each page owns its full-screen UI.
              Meeting links built by zoomShared.buildMeetingLink point at
              /appointment?session=… and auto-join as a participant. */}
            <Route path="/appointment" element={<ZoomAppointment />} />
            <Route path="/whiteboard" element={<ZoomWhiteboard />} />
            {/* Balance in Space consultations use their own Zoom room (compass/whiteboard). */}
            <Route path="/balance-in-space-zoom" element={<ZoomBalanceInSpaceAppointment />} />
            {/* Real sign-in is a modal in Tryoutpage; /login is only a legacy
              redirect target for older navigate("/login") call sites. */}
            <Route path="/login" element={<Navigate to="/main" replace />} />
            <Route path="/elementfinder" element={<ElementFinder />} />
            {/* <Route path="/DigitalCharm" element={<DigitalCharm />} /> */}

            <Route path="/" element={<MasterLayout />}>
              <Route path="/mainmasters" element={<MainPageM />} />
              <Route path="/images" element={<MasterImage />} />
              <Route path="/videoConference" element={<MasterList />} />
              <Route
                path="/masterappointments"
                element={<MasterAppointments />}
              />
            </Route>
            <Route path="/partner" element={<Partner />} />
            <Route path="/mainmaster" element={<MainMaster />} />
            <Route path="/wallet" element={<Wallet />} />
            <Route path="/checkout-demo" element={<CheckoutDemo />} />
            {/* Catch-all: without this, an unmatched path renders a blank page with
              no error. Logs the offending URL and recovers known cases. */}
            <Route path="*" element={<RouteFallback />} />
          </Routes>
          </RouteErrorBoundary>
          {/* ChatbotWrapper hides the chat button on appointment routes */}
          <ChatbotWrapper />
        </div>
      </ProfileProvider>
    </Router>
  );
}

export default App;

// Catches render-time crashes anywhere in the routed tree (e.g. SignUpPage throwing)
// and prints the real error + component stack to the console instead of failing
// silently to a white page.
class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error(
      `[App] Page crashed at "${window.location.pathname}${window.location.search}":`,
      error,
    );
    console.error("[App] Component stack:", info?.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 12,
            padding: 24,
            background: "#0A031E",
            color: "#DFBD69",
            fontFamily: "sans-serif",
            textAlign: "center",
          }}
        >
          <h2 style={{ margin: 0 }}>Something went wrong loading this page.</h2>
          <p style={{ maxWidth: 520, opacity: 0.8 }}>
            {String(this.state.error?.message || this.state.error)}
          </p>
          <p style={{ opacity: 0.6, fontSize: 13 }}>
            Open the browser console for the full error and component stack.
          </p>
          <button
            onClick={() => {
              window.location.href = `${ROUTER_BASENAME}/main`;
            }}
            style={{
              marginTop: 8,
              padding: "8px 20px",
              borderRadius: 25,
              border: "2px solid #DFBD69",
              background: "black",
              color: "#DFBD69",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Back to Home
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

// Rendered for any URL that matches no <Route>. React Router otherwise renders
// nothing here, which shows as an unexplained white page.
function RouteFallback() {
  const location = useLocation();
  const { pathname, search } = location;

  useEffect(() => {
    console.error(
      `[App] No route matched for "${pathname}${search}". ` +
        "The app is served from the domain root, so links must have no path prefix " +
        '(a signup link should look like "/signup/<code>?lang=<id>"). Redirecting…',
    );
  }, [pathname, search]);

  // Recover signup links that carry a stray prefix (e.g. an old "/xianhe/signup/XH555"
  // QR code) by collapsing everything before "/signup/<code>".
  const signupMatch = pathname.match(/\/signup(\/[^/]+)?\/?$/);
  if (signupMatch) {
    const target = `/signup${signupMatch[1] || ""}${search}`;
    console.warn(`[App] Recovering signup link -> "${target}"`);
    return <Navigate to={target} replace />;
  }

  return <Navigate to="/main" replace />;
}

// Sends a GA page_view whenever the route changes — the SPA never reloads, so
// gtag would otherwise only ever see the first page.
function PageViewTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    trackPageView(pathname + search);
  }, [pathname, search]);

  return null;
}

function ChatbotWrapper() {
  // useLocation must be called within Router; this wrapper is rendered inside Router
  const location = useLocation();
  const path = location?.pathname || "";

  // Hide chatbot on appointment-related routes, and on the full-page chat
  // routes where the conversation is already on screen
  const route = path.replace(/\/+$/, "") || "/";
  const hiddenRoutes = [
    "/mainmasters",
    "/images",
    "/videoConference",
    "/masterappointments",
    "/token-generator",
    "/whiteboard",
    "/partner",
    "/mainmaster",
    "/wallet",
    "/chat",
    "/chatbot",
    "/checkout",
    "/checkout-demo",
    "/cart",
    "/zoom-test",
    "/zoom-whiteboard",
    "/balance-in-space-zoom",
  ];
  const hide =
    path.startsWith("/appointment") ||
    path.startsWith("/create-room") ||
    hiddenRoutes.includes(route);
  if (hide) return null;
  return <Chatbot />;
}
